import { http } from '@/http'

export default {
  list(params)             { return http.get('/document-types', { params }) },
  get(id)                  { return http.get(`/document-types/${id}`) },
  save(data)               { return http.post('/document-types', data) },
  update(id, data)         { return http.put(`/document-types/${id}`, data) },
  changeStatus(id, status) { return http.put(`/document-types/${id}/status`, null, { params: { status } }) },
}
